import { NgModule } from '@angular/core';
import { ToastService } from './services/toast.service';
import { ToastService2 } from './services/toast2.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        ToastService,
        ToastService2,
    ],
})
export class ToastModule {

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/toast/toast.module.ts